import { inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ToastProvider } from '@core';
import { CasesRepository } from '../../../infrastructure/repositories/cases.repository';
import { GetClosingReasonsResult } from './get-closing-reasons.result';

/**
 * Get Closing Reasons Use Case
 *
 * Retrieves all active closing reasons for the Closing Notes modal dropdown.
 * These are tenant-specific and seeded from master tenant provisioning.
 */
@Injectable({ providedIn: 'root' })
export class GetClosingReasonsUseCase {
  private readonly _repository = inject(CasesRepository);
  private readonly _toast = inject(ToastProvider);

  /**
   * Execute use case
   * @returns Observable with closing reasons array
   */
  public execute(): Observable<GetClosingReasonsResult> {
    return this._repository.getClosingReasons().pipe(
      map((reasons) => ({ reasons })),
      catchError((error) => {
        this._toast.error(
          'Failed to load closing reasons',
          'Please refresh and try again.'
        );
        return throwError(() => error);
      })
    );
  }
}
